import { useQueryClient } from '@tanstack/react-query';
import { type FolderAsset, createFolderAsset } from 'models';
import { useMutation } from 'query';
import type { FolderAssetDataObject } from 'models/service';
import { createAsset } from '../../services';
import { assetsFeatureKey } from '../keys';

export const useCreateFolderMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<FolderAsset, { communityId?: string; name: string; parentId?: string; programId?: string }>({
    async mutationFn({ communityId, name, parentId, programId }) {
      const body = new FormData();

      body.append('name', name);
      body.append('type', 'folder');

      if (communityId) {
        body.append('community_id', communityId);
      }

      if (programId) {
        body.append('program_id', programId);
      }

      if (parentId) {
        body.append('parent_id', parentId);
      }

      const response = await createAsset({ body });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- The create endpoint returns a folder when the request created a folder
      return createFolderAsset(response.data as unknown as FolderAssetDataObject);
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: assetsFeatureKey });
    },
  });
};
